(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initHero(root) {
    // Guard against double-binding when the theme editor re-runs init.
    if (root.getAttribute('data-td-hero-ready') === 'true') return;

    var slides = root.querySelectorAll('[data-td-slide-index]');
    var dots = root.querySelectorAll('[data-td-hero-dot]');
    var prevBtn = root.querySelector('[data-td-hero-prev]');
    var nextBtn = root.querySelector('[data-td-hero-next]');
    if (slides.length < 2) return;

    root.setAttribute('data-td-hero-ready', 'true');

    var current = 0;
    var auto = root.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(root.getAttribute('data-autoplay-speed') || '5', 10) * 1000;
    var timer = null;

    function show(target) {
      var total = slides.length;
      var next = target;
      while (next < 0) next = next + total;
      next = next - (Math.floor(next / total) * total);
      current = next;
      for (var i = 0; i < slides.length; i++) {
        if (i === current) {
          slides[i].classList.add('is-active');
        } else {
          slides[i].classList.remove('is-active');
        }
      }
      for (var j = 0; j < dots.length; j++) {
        if (j === current) {
          dots[j].classList.add('is-active');
          dots[j].setAttribute('aria-selected', 'true');
        } else {
          dots[j].classList.remove('is-active');
          dots[j].setAttribute('aria-selected', 'false');
        }
      }
    }

    function start() {
      // Never auto-advance for visitors who asked for reduced motion.
      if (auto && !reduceMotion.matches && !timer) {
        timer = setInterval(function () { show(current + 1); }, speed);
      }
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () { show(current - 1); stop(); start(); });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () { show(current + 1); stop(); start(); });
    }
    dots.forEach(function (d, idx) {
      d.addEventListener('click', function () { show(idx); stop(); start(); });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    // ----- Touch swipe -----
    // Listeners are passive so the page keeps scrolling at native speed; a
    // gesture only counts as a swipe if it is clearly more horizontal than
    // vertical, otherwise a normal downward scroll would flip slides.
    var touchX = 0;
    var touchY = 0;
    var tracking = false;

    root.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      touchX = e.touches[0].clientX;
      touchY = e.touches[0].clientY;
      tracking = true;
      stop();
    }, { passive: true });

    root.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var touch = e.changedTouches[0];
      var dx = touch.clientX - touchX;
      var dy = touch.clientY - touchY;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        show(dx < 0 ? current + 1 : current - 1);
      }
      start();
    }, { passive: true });

    root.addEventListener('touchcancel', function () {
      tracking = false;
      start();
    }, { passive: true });

    // If the visitor flips the OS setting mid-visit, honour it immediately.
    if (reduceMotion.addEventListener) {
      reduceMotion.addEventListener('change', function () {
        stop();
        start();
      });
    }

    // Exposed so the Shopify theme editor hooks below can drive this instance.
    root.tdHero = { show: show, start: start, stop: stop };

    start();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-td-hero]').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // ----- Shopify theme editor -----
  // Section HTML is swapped in via innerHTML, which never re-executes an
  // external script tag, so the carousel has to re-bind itself on reload.
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });

  // Selecting a slide block in the editor should bring that slide into view,
  // and hold it there while it is being edited.
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest('[data-td-slide-index]');
    var root = e.target.closest('[data-td-hero]');
    if (!root || !root.tdHero || !slide) return;
    root.tdHero.show(parseInt(slide.getAttribute('data-td-slide-index'), 10) || 0);
    root.tdHero.stop();
  });

  document.addEventListener('shopify:block:deselect', function (e) {
    var root = e.target.closest('[data-td-hero]');
    if (root && root.tdHero) root.tdHero.start();
  });
})();